import Popup from './Popup';
import './Popup.scss';

export default Popup;